import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useProfile } from '@/store';

export const useProfileModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile } = useProfile();

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const currentProfileId = searchParams.get('profileId') || undefined;

  const openProfile = useCallback(
    (userId?: string) => {
      const id = userId ?? profile?._id;
      if (!id) return;
      const params = new URLSearchParams(location.search);
      params.set('profileId', id);
      navigate({ pathname: location.pathname, search: `?${params.toString()}` });
    },
    [location.pathname, location.search, navigate, profile?._id]
  );

  const closeProfile = useCallback(() => {
    const params = new URLSearchParams(location.search);
    params.delete('profileId');
    navigate({ pathname: location.pathname, search: `?${params.toString()}` }, { replace: true });
  }, [location.pathname, location.search, navigate]);

  const isOpen = !!currentProfileId;

  return { openProfile, closeProfile, isOpen, profileId: currentProfileId };
};
